<template>
  <div class="darkbg" @click="$emit('update:showShare', false)" v-show="showShare">
    <div class="darkdiv">
      <img class="shareJiantou" src="@/assets/goodDetails/jiantou.png" />
      <div class="darkt1">请点击右上角</div>
      <div>将它发送给指定朋友</div>
      <div>或分享到朋友圈</div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["showShare"],
};
</script>

<style lang="stylus" scoped>
.darkbg {
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: 1000;
  background: rgba(0, 0, 0, 0.6);
  top: 0;
  left: 0;

  .darkt1 {
    margin-top: 10px;
  }

  .darkdiv {
    float: right;
    font-size: 16px;
    color: #fff;
    text-align: right;
    margin-right: 20px;
  }

  .shareJiantou {
    width: 86px;
    height: 153px;
  }
}
</style>